export default "/images/f1a381ae4680d13d68341f01b2c0ac49.avif";